.profileItemContent {
  max-width: unset;
}
